import React, { useState } from 'react';
import './App.css';
import './NodeInfoPanel.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";

const AddNodeForm = ({ onAddNode }) => {
    const [newNodeData, setNewNodeData] = useState({
        id: '',
        description: '',
        type: 'evidence',
        references: []
    });
    const { t } = useTranslation();

    const handleSubmit = (e) => {
        e.preventDefault();
        onAddNode(newNodeData);
        setNewNodeData({
            id: '',
            description: '',
            type: 'evidence',
            references: []
        });
    };

    const handleIdChange = (e) => {
        const value = e.target.value.slice(0, 25);
        setNewNodeData({ ...newNodeData, id: value });
    };

    return (
        <Card sx={{ mt: 2, mb: 1 }}>
            <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                    {t('info.addnode')}
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        '& > :not(style)': { mb: 1 },
                        '& .MuiInputBase-root': {
                            fontSize: '0.875rem'
                        },
                        '& .MuiInputLabel-root': {
                            fontSize: '0.875rem',
                            transform: 'translate(14px, 10px) scale(1)'
                        },
                        '& .MuiInputLabel-shrink': {
                            transform: 'translate(14px, -6px) scale(0.75)'
                        }
                    }}
                >
                    <TextField
                        fullWidth
                        id="node-title"
                        label={t('info.nodetitle')}
                        variant="outlined"
                        value={newNodeData.id}
                        onChange={handleIdChange}
                        placeholder={t('info.entertitle')}
                        required
                        inputProps={{ maxLength: 25 }}
                        size="small"
                        margin="dense"
                    />

                    <FormControl fullWidth size="small" margin="dense">
                        <InputLabel id="node-type-label">Node Type</InputLabel>
                        <Select
                            labelId="node-type-label"
                            id="node-type"
                            value={newNodeData.type}
                            label="Node Type"
                            onChange={(e) => setNewNodeData({ ...newNodeData, type: e.target.value })}
                         >
                            <MenuItem value="evidence">{t('info.evidence')}</MenuItem>
                            <MenuItem value="model">{t('info.model')}</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        id="node-description"
                        label={t('info.description')}
                        variant="outlined"
                        value={newNodeData.description}
                        onChange={(e) => setNewNodeData({ ...newNodeData, description: e.target.value })}
                        placeholder="Enter node description"
                        required
                        multiline
                        rows={3}
                        size="small"
                        margin="dense"
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="small"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 500,
                            py: 0.5,
                            mt: 0.5
                        }}
                    >
                        {t('info.addnode')}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default AddNodeForm;